export default "__VITE_ASSET__IeUs0NFe__"